import { connect } from "react-redux";
import { userConstants } from "../../constants/ActionTypes";


const initialState = {
    virtual_acnt_created : false,
    acnt_balance : "",
    available_balance:"0",
    hold_balance:"0",
    usable_balance:"0",
    company_name : "",
    account_number : "",
    ifsc : "",
    business:{},
    contact_name:"",
    amount:"",
    note:"",
    pay_mode:"",
    trans_ref:"",
    showBankTransfer:false,
    showVerifcation:false,
    account_number_bank : "",
    confirm_account_number_bank:"",
    ifsc_bank : "",
    upivpaModal:false,
    upivpabank:"yesbank",
    upivpaid:"",
    show_upi_error:false,
    upi_id:"",
    TransactionList : [],
    page : 1,
    limit : 10,
    totalPage : 0,
    isTransDetail: false,
    checkMode:null,
    dashboardResults:{},
    dashboardPayoutTotalResults:{},
    dashboardPayoutCountResults:{},
    upi_vpa_id:"",
    // fromDate:new Date(),
    // toDate:new Date(),
    open_picker : false,
    startDate : new Date(),
    endDate : new Date(),
    from: "",
    to: "",
    fromDate:  "",
    toDate: "",
    dashboard_transaction:{},
    account_type:"bank_account",
    account_type_bank:false,
    upi_verify:"",
    ifsc_verify:"",
    account_number_verify:"",
    confirim_account_number_verify:"",
    upi_screen:false,
    account_screen:false,
    amount_verify:1,
    remarks:"Penny Drop",
    pay_mode_verify:"IMPS",
    save_contact_check:false,
    save_upi_contact_check:false,
    contact_name_verify:"",
    contact_upi_name_verify:"",
    mPin:"",
    merchantProfile:[],
    transPinStatus:"",
    lastSevenDaysPayinTransactionDetails:{},
    upi_vpa_transfer_fund:"",
    bank_name:"",
    connected_account_number:"",
    connected_ifsc:"",
    connected_holder_name:"",
    connected_bank_name:"",
    connected_logo:"",
    account_id:"",
    name:""
};

export function dashboard(state = initialState, action) {
    switch (action.type) {  
        case userConstants.DASHBOARD:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state
    }
}